import type { AccountTrip, AccountTripPage } from '../api'

export interface LoadedTripListState {
  trips: AccountTrip[]
  hasEarlier: boolean
  error?: string
}

export function includesNewTrip(knownTripIds: ReadonlySet<string>, trips: AccountTrip[]): boolean {
  return trips.some((trip) => !knownTripIds.has(trip.id))
}

export function applyTripListRefresh<T extends LoadedTripListState>(
  current: T,
  page: AccountTripPage,
): T {
  return {
    ...current,
    trips: page.trips,
    hasEarlier: page.hasEarlier,
    error: undefined,
  }
}
